const ZH = 'zh';
const EN = 'en';
const SUPPORT_LANG_LIST = [ZH, EN];
const LANG_QUERY_STRING = 'lang';
const LANG_LOCAL_STORAGE_KEY = 'yaotai_conference_lang';
const LANGUAGE_LIST = [ZH, EN];
const FALLBACK_LANG = ZH;

export { EN, FALLBACK_LANG, LANGUAGE_LIST, LANG_LOCAL_STORAGE_KEY, LANG_QUERY_STRING, SUPPORT_LANG_LIST, ZH };
